export default "__VITE_ASSET__DRbenQUm__"